/**
 *
 * FreshPets Theme
 *
 */
import { lighten } from '@theme-ui/color'
import alpha from './alpha'
import borders from './borders'
import breakpoints from './breakpoints'
import colors from './colors'
import durations from './durations'
import fontSizes from './font-sizes'
import fontWeights from './font-weights'
import fonts from './fonts'
// import lineHeights from './line-heights'
import opacities from './opacities'
import radii from './radii'
import ratios from './ratios'
import space from './space'

const theme = {
    useCustomProperties: true,
    useBodyStyles: true,
    useColorSchemeMediaQuery: true,
    alpha,
    borders,
    breakpoints,
    colors,
    durations,
    fonts,
    fontSizes,
    fontWeights,
    // lineHeights,
    opacities,
    radii,
    ratios,
    space,
    text: {
        default: {
            color: 'text',
            fontFamily: 'body',
            fontWeight: 'body',
            lineHeight: 'body'
        },
        // paragraph: {
        //     color: 'text',
        //     fontFamily: 'body',
        //     fontWeight: 'body',
        //     lineHeight: 'heading'
        // },
        heading: {
            color: 'primary',
            fontFamily: 'heading',
            fontWeight: 'heading',
            lineHeight: 'heading'
        }
    },
    layout: {
        container: {
            maxWidth: '1200px'
        }
    },
    links: {
        nav: {
            color: 'white',
            fontSize: [3, 4, 5],
            p: 3,
            transition: `background-color ${durations[1]} ease`,
            borderRadius: 2,
            ':hover': {
                color: 'white',
                backgroundColor: ({ ratios }) => lighten('primary', ratios[0])
            }
        },
        button: {
            primary: {
                width: 'auto',
                display: 'inline-block',
                fontFamily: 'heading',
                fontWeight: 'body',
                color: 'white',
                cursor: 'pointer',
                backgroundColor: 'primary',
                px: 3,
                py: 2,
                borderRadius: 2,
                fontSize: 3,
                outline: 'none',
                textDecoration: 'none',
                textAlign: 'center',
                transition: `background-color ${durations[1]} ease`,
                ':hover': {
                    border: 'none 0 transparent',
                    bg: 'primary_dark'
                }
            },
            secondary: {
                variant: 'links.button.primary',
                backgroundColor: 'secondary',
                ':hover': {
                    variant: 'links.button.primary.:hover',
                    bg: 'primary_dark'
                }
            }
        },
        footer: {
            textDecoration: 'none',
            color: 'white',
            fontFamily: 'body',
            fontWeight: 'fine',
            fontSize: [5, 3, 4],
            transition: ({ durations }) => `color ${durations[1]} ease`,
            '&:hover': {
                color: 'primary'
            }
        },
        small: {
            variant: 'links.footer',
            color: 'white',
            fontSize: 3
        }
    },
    styles: {
        root: {
            // uses the theme values provided above
            fontFamily: 'body',
            fontWeight: 'body'
        },
        h1: {
            variant: 'text.heading',
            px: 3,
            fontSize: 6
        },
        h2: {
            variant: 'text.heading',
            px: 3,
            fontSize: 5,
            mt: [space[3], space[4], space[5]],
            mb: [space[2], space[3], space[4]]
        },
        p: {
            px: 3
        },
        ol: {
            li: {
                counterIncrement: 'list',
                listStyleType: 'none',
                position: 'relative',
                '&:before': {
                    color: 'primary',
                    content: 'counter(list) "."',
                    left: '-26px',
                    position: 'absolute',
                    textAlign: 'center',
                    width: '26px'
                }
            }
        },
        ul: {
            listStyleType: '🐶',
            li: {
                '&::marker': {
                    color: 'primary'
                }
            }
        }
    }
}

export default theme